module.exports = __webpack_public_path__ + "static/media/clockOnPower.3333f094.svg";